import {Component, Input, Output, ViewChild, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import {FormBuilder, Validators, FormGroup, FormControl} from '@angular/forms';
import {DomSanitizer} from '@angular/platform-browser'

import {ModalDirective} from "ng2-bootstrap";
import {Http} from '@angular/http';
import {environment} from "../../../../environments/environment";

import * as html2canvas from "html2canvas";

@Component({
    selector: 'widget-type-modal',
    templateUrl: './widget-type.modal.component.html',
    styleUrls: [ './widget-type.modal.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
  export class WidgetTypeComponent {

    public widgetTypes = [];
    private backendUrl = environment.backendUrl;

    @ViewChild('widgetTypeModal') 
    public widgetTypeModal: ModalDirective;

    @Output()
    public widgetType = new EventEmitter<boolean>();  

    @Input()
    public addWidget;

    constructor(private http: Http, private sanitizer: DomSanitizer, private cdr: ChangeDetectorRef) {
      this.http.get(this.backendUrl+'api/template')
          .subscribe(
                  data => {
                    this.widgetTypes = data.json().map( (e) => JSON.parse(e) );
                    this.widgetTypes.map((e: any) => e.html)
                    this.cdr.detectChanges();
                  },
                  error => { }
          );
    }

    preview(e) {
      return  this.sanitizer.bypassSecurityTrustHtml(e.html + ' <style> ' + e.css + ' </style>');
    }

    show() {
      this.widgetTypeModal.show(); 
      this.widgetType.emit();
    }

    select(widget) {
      this.addWidget(widget.html, widget.css);
      this.widgetTypeModal.hide();
    }

}



// WEBPACK FOOTER //
// /code/frontend/src/app/main/editor/modals/widget-type.modal.component.ts